import { RepresentanteLegal } from './../modelos/representante-legal';
import { Solicitante } from './../modelos/solicitante';
import { ExSegurado } from './../modelos/ex-segurado';
import { MensagemSucessoComponent } from './../modal/mensagem-sucesso/mensagem-sucesso.component';
import { Cidade } from './../modelos/cidade';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ConsumirApiService } from '../consumir-api.service';
import { Router } from '@angular/router';
import { Cadastro } from '../modelos/cadastro';
import { MensagemErroComponent } from '../modal/mensagem-erro/mensagem-erro.component';
import { MatDialog } from '@angular/material';
import { Orgao } from '../modelos/orgao';
import { TipoSolicitacao } from '../modelos/tipoSolicitacao';
import { ObservacaoAnexosComponent } from '../modal/observacao-anexos/observacao-anexos.component';
import * as CEP_LIB from 'cep-promise/dist/cep-promise-browser.js';
import { EstadoCivil } from '../modelos/estadoCivil';
import { TipoSolicitante } from '../modelos/tipoSolicitante';
import { Mutuario } from '../modelos/mutuario';
import { SolicitanteImobiliario } from '../modelos/solicitanteImobiliario';

@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CadastroComponent implements OnInit {

  servidor: Cadastro;
  solicitante_imobiliario: SolicitanteImobiliario;
  mutuario: Mutuario;
  representanteLegal: RepresentanteLegal;
  orgaos: Orgao[];
  estadoCivil:EstadoCivil[];
  tipoSolicitante: TipoSolicitante[];
  tipo_solicitacao: TipoSolicitacao[];
  cidades: Cidade[];
  infoContaCorrente = false;
  formulario;
  email_solicitacao;
  codigo_validacao;
  email_validado = false;

  status_formularios = {
    informacoes_importantes: true,
    confirmacao_email: false,
    exSegurado: false,
    solicitante: false,
    anexos: false,
    termo_responsabilidade: false
  };
  step = 0;

  teste_arquivos = [];

  formData: FormData;
  leitura_termo = false;
  infoImpostoDeRenda: boolean;
  infoSolicitacaoAnterior: boolean;
  informacaoExtratoCnis: boolean;
  informacaoUniaoEstavel: boolean;
  informacaoSentencaCuratela: boolean;


  constructor(
    private _api: ConsumirApiService,
    private _rota: Router,
    private _dialog: MatDialog) {
  }

  ngOnInit() {
    this.servidor = new Cadastro();
    this.mutuario =  new Mutuario();
    this.solicitante_imobiliario = new SolicitanteImobiliario();
    this.representanteLegal = new RepresentanteLegal();
    this.representanteLegal.nome_completo = '';
    this.representanteLegal.rg = '';
    this.representanteLegal.cpf = '';
    this.mutuario.nome_completo = '';
    this.mutuario.cpf = '';
    this.mutuario.orgao_id = 0;
    this.mutuario.estado_civil_id = 0;
    this.mutuario.matricula = '';
    this.mutuario.matricula_dois = '';
    this.mutuario.cargo = '';
    this.solicitante_imobiliario.nome_solicitante = '';
    this.solicitante_imobiliario.cpf = '';
    this.solicitante_imobiliario.endereco = '';
    this.solicitante_imobiliario.complemento = '';
    this.solicitante_imobiliario.telefone = '';
    this.solicitante_imobiliario.telefone_secundario = '';
    this.solicitante_imobiliario.email = '';
    this.solicitante_imobiliario.cep = '';
    this.solicitante_imobiliario.bairro = '';
    this.solicitante_imobiliario.tipo_solicitante_id = 0;
    this.solicitante_imobiliario.cidade_id = 1; //gambiarra pra não quebrar o cidade_id no banco (foi colocado CEP automático).
    this._api.buscaOrgaos().subscribe(
      data => {
        this.orgaos = data;
      }, () => { }
    );
    this._api.buscaEstadoCivil().subscribe(
      data => {
        this.estadoCivil = data;
      }, () => { }
    );
    this._api.buscaTipoSolicitante().subscribe(
      data => {
        this.tipoSolicitante = data;
      }, () => { }
    );
    this._api.buscaTipoSolicitacao().subscribe(
      data => {
        this.tipo_solicitacao= data[0].id;
        //console.log(this.tipo_solicitacao)
      }, () => { }
    );
  }

  async verificaCEP(event) {
    if(this.solicitante_imobiliario.cep.length == 8) {
      const resultado = await CEP_LIB(this.solicitante_imobiliario.cep);
      this.solicitante_imobiliario.cidade = resultado.city;
      this.solicitante_imobiliario.bairro = resultado.neighborhood;
      this.solicitante_imobiliario.endereco = resultado.street;
      this.solicitante_imobiliario.estado = resultado.state;
    }
  }

  verificarEmailSolicitante() {
    const er = new RegExp(/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/);
    if (this.solicitante_imobiliario.email.length < 1 || !er.test(this.solicitante_imobiliario.email)) {
      this.exibirMensagemErro('Por favor, digite um email válido.');
      return 0;
    }

    this._api.verificarEmailSolicitante(this.solicitante_imobiliario.email).subscribe(
      data => {
       // console.log(data);
        if (data.codigo_resposta == 0) {
          // console.log(data);
          this.exibirMensagemErro(data.mensagem);
        } else {
          if (data.validado) {

            const modal = this._dialog.open(MensagemSucessoComponent, {
              data: {
                titulo: `${data.mensagem}!`,
                mensagem: `<p>Você pode agora prosseguir com a sua solicitação!</p>`
              },
              hasBackdrop: true,
              disableClose: true
            });

            modal.afterClosed().subscribe(() => {
              this.status_formularios.exSegurado = true;
              this.setStep(2);
            });
          } else {
            this.email_validado = true;
          }
        }
      }
    );
  }

  validarEmailSolicitante() {
    if (this.codigo_validacao.length < 1) {
      this.exibirMensagemErro('Por favor, verifique o código no seu e-mail e digite no campo solicitado.');
      return 0;
    }
    this._api.validarEmailSolicitante(this.solicitante_imobiliario.email, this.codigo_validacao).subscribe(
      data => {
        if (data.validado) {
          const modal = this._dialog.open(MensagemSucessoComponent, {
            data: {
              titulo: `${data.mensagem}!`,
              mensagem: `<p>Caso queira abrir uma nova solicitação com este e-mail, não será mais necessário realizar este passo.</p>
              <p>Você pode agora prosseguir com a sua solicitação!</p>`
            },
            hasBackdrop: true,
            disableClose: true
          });

          modal.afterClosed().subscribe(() => {
            this.status_formularios.exSegurado = true;
            this.setStep(2);
          });
        } else {
          this.exibirMensagemErro(data.mensagem);
        }
      }
    );
  }

  verificaAnexoProcurador(): boolean {

      if (this.solicitante_imobiliario.tipo_solicitante_id ==2) {
        return true;
      }
    return false;
  }

  carregaTipoSolicitante() {

   // console.log(this.mutuario.estado_civil_id)
    this._api.buscaTipoSolicitante().subscribe(
      data => {
        this.tipoSolicitante = data;
        //console.log(this.tipoSolicitante)
        this.resetOpcoes();
      }, () => { }
    );
  }
  resetOpcoes() {
    // resetando os expansions que irão aparecer
    this.status_formularios = {
      informacoes_importantes: true,
      confirmacao_email: true,
      exSegurado: true,
      solicitante: false,
      anexos: false,
      termo_responsabilidade: false
    };
    this.solicitante_imobiliario.tipo_solicitante_id = 0;
    this.teste_arquivos = [];
  }

  resetTipoSolicitacao() {
    //console.log(this.solicitante_imobiliario.tipo_solicitante_id)

    // resetando os expansions que irão aparecer
    this.status_formularios = {
      informacoes_importantes: true,
      confirmacao_email: true,
      exSegurado: true,
      solicitante: true,
      anexos: false,
      termo_responsabilidade: false
    };
    // resetando lista de anexos
    this.teste_arquivos = [];
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStepInformacao() {
    this.step++;
    this.status_formularios.confirmacao_email = true;
  }

  nextStepMutuario() {
    if (this.step === 2 && this.validarCamposMutuario() === 0) {
      if (this.step === 2) {
        this.step++;
        this.status_formularios.solicitante = true;
      }
    }
  }

  nextStepSolicitante() {
    if (this.step === 3 && this.validarCamposSolicitante() === 0) {
      this.step = this.step + 2;
      this.status_formularios.anexos = true;
    }
  }

  nextStepAnexo() {
    if (this.verificarInputs() === 0) {
      this.step++;
      this.status_formularios.termo_responsabilidade = true;
    }
  }

  prevStep() {
    if (this.step === 5) {
      this.step -= 2;
    } else {
      this.step--;
    }
  }

  onChange(event) {
    const selectedFiles = <FileList>event.srcElement.files;
    // console.log(selectedFiles[0].type.includes('pdf'));
    const tamanhoArquivo = (selectedFiles[0].size / 1024) / 1024; // transformando byte em MB.

    if (tamanhoArquivo > 10) {
      this.exibirMensagemErro('O tamanho do arquivo deve ser menor que 10MB.');
    } else if (!selectedFiles[0].type.includes('pdf')) {
      this.exibirMensagemErro('O arquivo deve ser do tipo PDF.');
    } else {
      document.getElementById(event.target.labels[0].id).innerHTML = selectedFiles[0].name;

      const indice = this.verificaSeArquivoJaEstaNaLista(event.target.labels[0].id);

      if (indice !== -1) {
        this.teste_arquivos[indice] = {
          nome: event.target.labels[0].id,
          arquivo: selectedFiles[0]
        };
      } else {
        this.teste_arquivos.push({
          nome: event.target.labels[0].id,
          arquivo: selectedFiles[0]
        });
      }
    }
  }

  cadastrar() {

    if (this.leitura_termo) {
      if (this.validarCamposMutuario() === 0 && this.validarCamposSolicitante() === 0) {
        this.formData = new FormData();
        this.formData.set('mutuario', JSON.stringify(this.mutuario));
        this.formData.set('solicitante_imobiliario', JSON.stringify(this.solicitante_imobiliario));
        this.formData.set('tipo_solicitacao_id',  JSON.stringify(this.tipo_solicitacao))

        for (let i = 0; i < this.teste_arquivos.length; i++) {
          this.formData.append('arquivos', this.teste_arquivos[i].arquivo, this.teste_arquivos[i].nome);
        }

        this._api.cadastrar(this.formData).subscribe(
          data => {
            if (data.codigo_resposta === 1) {
              const modal = this._dialog.open(MensagemSucessoComponent, {
                data: {
                  titulo: 'Sua solicitação foi recebida com sucesso!',
                  mensagem: '<p>Foi encaminhado um e-mail de confirmação do recebimento da documentação.</p>' +
                    '<p>Após análise e validação dos documentos anexados, você receberá o número do processo no e-mail informado.</p>' +
                    '<p>Caso não receba e-mail, verifique sua caixa de spam.</p>'
                },
                hasBackdrop: true,
                disableClose: true
              });

              modal.afterClosed().subscribe(() => {
                this._rota.navigate(['/']);
              });
            } else {
              const modal = this._dialog.open(MensagemErroComponent, {
                data: { mensagem_erro: 'Não foi possível abrir sua solicitação, tente novamente mais tarde.' },
                hasBackdrop: true,
                disableClose: true
              });

              modal.afterClosed().subscribe(() => {
                //this._rota.navigate(['/']);
              });
            }
          },
          (err) => {
            this.exibirMensagemErro('Não foi possível abrir sua solicitação, tente novamente mais tarde.');
            console.log(err);
            //this._rota.navigate(['/']);
          }
        );
      }
    } else {
      this.exibirMensagemErro('Por favor, leia os termos de responsabilidade/ciência e marque a caixa de confirmação de leitura.');
    }
  }

  verificaSeArquivoJaEstaNaLista(nome_campo: string): number {
    for (let i = 0; i < this.teste_arquivos.length; i++) {
      const indice = this.teste_arquivos[i].nome.indexOf(nome_campo);

      if (indice !== -1) {
        return i; // existe o arquivo e eu retorno o indice pra sobrescrever.
      }
    }
    return -1; // não existe o arquivo ainda.
  }

  validarCamposSolicitante() {
    const er = new RegExp(/^[A-Za-z0-9_\-\.]+@[A-Za-z0-9_\-\.]{2,}\.[A-Za-z0-9]{2,}(\.[A-Za-z0-9])?/);
    if (this.solicitante_imobiliario.nome_solicitante.trim().length < 1) {
      this.exibirMensagemErro('Por favor, digite seu nome completo.');
      return 1;
    }
    if (this.solicitante_imobiliario.cpf.trim().length < 11) {
      this.exibirMensagemErro('Por favor, digite seu cpf.');
      return 1;
    }

    if (this.solicitante_imobiliario.cep.trim().length < 8) {
      this.exibirMensagemErro('Por favor, informe o CEP');
      return 1;
    }

    if (this.solicitante_imobiliario.endereco.trim().length < 1) {
      this.exibirMensagemErro('Por favor, digite seu logradouro e número.');
      return 1;
    }

    if (this.solicitante_imobiliario.bairro.trim().length < 1) {
      this.exibirMensagemErro('Por favor, digite seu bairro.');
      return 1;
    }

    if (this.solicitante_imobiliario.telefone.trim().length < 11) {
      this.exibirMensagemErro('Por favor, digite seu telefone com DDD.');
      return 1;
    }

    if (this.solicitante_imobiliario.email.length < 1 || !er.test(this.solicitante_imobiliario.email)) {
      this.exibirMensagemErro('Por favor, digite um email válido.');
      return 1;
    }

    if (this.solicitante_imobiliario.tipo_solicitante_id == 0) {
      this.exibirMensagemErro('Por favor, informe se possui procuração.');
      return 1;
    }

    return 0;
  }

  validarCamposMutuario() {
    if (this.mutuario.nome_completo.trim().length < 1) {
      this.exibirMensagemErro('Por favor, digite o nome completo do mutuário.');
      return 1;
    }

    if (this.mutuario.cpf.trim().length < 11) {
      this.exibirMensagemErro('Por favor, digite o cpf do mutuário.');
      return 1;
    }

    if (this.mutuario.orgao_id == 0) {
      this.exibirMensagemErro('Por favor, escolha o órgão na qual o mutuário está vinculado.');
      return 1;
    }

    if (this.mutuario.matricula.trim().length < 1) {
      this.exibirMensagemErro('Por favor, digite a matrícula do mutuário.');
      return 1;
    }

    if (this.mutuario.cargo.trim().length < 1) {
      this.exibirMensagemErro('Por favor, digite o cargo do mutuário.');
      return 1;
    }
    if (this.mutuario.estado_civil_id == 0) {
      this.exibirMensagemErro('Por favor, informe o estado civil do mutuário');
      return 1;
    }
    return 0;
  }

  exibirMensagemErro(titulo, mensagem?) {
    this._dialog.open(MensagemErroComponent, {
      data: {
        titulo: titulo,
        mensagem: mensagem
      },
      hasBackdrop: true,
      disableClose: true
    });
  }

  exibirMensagemSucesso(titulo, mensagem?) {
    this._dialog.open(MensagemSucessoComponent, {
      data: {
        titulo: titulo,
        mensagem: mensagem
      },
      hasBackdrop: true,
      disableClose: true
    });
  }

  exibirMensagemAviso(titulo, mensagem?) {
    this._dialog.open(ObservacaoAnexosComponent, {
      data: {
        titulo: titulo,
        mensagem: mensagem
      },
      hasBackdrop: true,
      disableClose: false
    });
  }

  verificarInputs() {
    /** não validei o contracheque e sentença de pensão e sentença de curatela, pq não é obrigatório. */
    const listaInputs =
      [
        'anexo-mutuario-rg',
        'anexo-mutuario-cpf',
        'anexo-comprovante-residencia-mutuario',
        'anexo-casado-rg',
        'anexo-casado-cpf',
        'anexo-uniao-estavel-rg',
        'anexo-uniao-estavel-cpf',
        'anexo-viuvo-rg',
        'anexo-viuvo-cpf',
        'anexo-divorciado-rg',
        'anexo-divorciado-cpf',
        'anexo-separado-rg',
        'anexo-separado-cpf',
        'anexo-rg-procurador',
        'anexo-cpf-procurador',
        'anexo-comprovante-residencia-procurador',
        'anexo-procuração-publica-procurador',
        'anexo-foto-selfie-procurador'

      ];
      for (let i = 0; i < listaInputs.length; i++) {
        if (document.getElementById(listaInputs[i])) {
          if (document.getElementById(listaInputs[i]).innerText.length === 0) {
            this.exibirMensagemErro(this.transformarIdInputEmString(listaInputs[i]));
            return 1;
            }
          }
      }
    return 0;
  }

  transformarIdInputEmString(input: string) {
    switch (input) {
      //Do Mutuário
      case 'anexo-mutuario-rg':
        return 'Favor anexar o RG ou CNH do(a) Mutuário(a).';
      case 'anexo-mutuario-cpf':
        return 'Favor anexar o CPF do(a) Mutuário(a).';
      case 'anexo-comprovante-residencia-mutuario':
        return 'Favor anexar o Comprovante de residência do(a) Mutuário(a).';

      // Do Casado(a)
      case 'anexo-casado-rg':
        return 'Favor anexar o RG do(a) Esposo(a).';
      case 'anexo-casado-cpf':
        return 'Favor anexar o CPF do(a) Esposo(a).';

      // Do União Estável
      case 'anexo-uniao-estavel-rg':
        return 'Favor anexar o RG do(a) Companheiro(a).';
      case 'anexo-uniao-estavel-cpf':
        return 'Favor anexar o CPF do(a) Companheiro(a).';

      // Do Viúvo(a)
      case 'anexo-viuvo-rg':
        return 'Favor anexar o RG do(a) Viúvo(a).';
      case 'anexo-viuvo-cpf':
        return 'Favor anexar o CPF do(a) Viúvo(a).';

      // Do Divorciado(a)
      case 'anexo-divorciado-rg':
        return 'Favor anexar o RG do(a) Divorciado(a).';
      case 'anexo-divorciado-cpf':
        return 'Favor anexar o CPF do(a) Divorciado(a).';

      // Do Separado(a)
      case 'anexo-separado-rg':
        return 'Favor anexar o RG do(a) Separado(a).';
      case 'anexo-separado-cpf':
        return 'Favor anexar o CPF do(a) Separado(a).';

      // Do Procurador
      case 'anexo-rg-procurador':
        return 'Favor anexar o RG do(a) Procurador(a)';
      case 'anexo-cpf-procurador':
        return 'Favor anexar o CPF do(a) Procurador(a)';
      case 'anexo-comprovante-residencia-procurador':
        return 'Favor anexar o comprovante de residência do(a) Procurador(a)';
      case 'anexo-procuração-publica-procurador':
        return 'Favor anexar a Procuração Pública e Substabelecimento de Procuração ';
      case 'anexo-foto-selfie-procurador':
        return 'Favor anexar uma Foto Selfie datada com dia do pedido';
      default:
        return '';
    }
  }
}
